function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00002 5.62449C8.73335 5.62449 9.33335 5.02449 9.33335 4.29116C9.33335 3.55782 8.73335 2.95782 8.00002 2.95782C7.26669 2.95782 6.66669 3.55782 6.66669 4.29116C6.66669 5.02449 7.26669 5.62449 8.00002 5.62449ZM8.00002 6.95782C7.26669 6.95782 6.66669 7.55782 6.66669 8.29116C6.66669 9.02449 7.26669 9.62449 8.00002 9.62449C8.73335 9.62449 9.33335 9.02449 9.33335 8.29116C9.33335 7.55782 8.73335 6.95782 8.00002 6.95782ZM8.00002 10.9578C7.26669 10.9578 6.66669 11.5578 6.66669 12.2912C6.66669 13.0245 7.26669 13.6245 8.00002 13.6245C8.73335 13.6245 9.33335 13.0245 9.33335 12.2912C9.33335 11.5578 8.73335 10.9578 8.00002 10.9578Z",
  fill: "black",
  fillOpacity: 0.54
});

var SvgEditIcon = function SvgEditIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EditIcon.b18c98ca.svg";
export { ForwardRef as ReactComponent };